module.exports = __webpack_public_path__ + "img/prod_delight.7211ac60.svg";